import { PatientCaseComplexityType } from 'models/MedicalRecord'
import styled from 'styled-components'

interface OptionStylesProps {
  isSelected: boolean;
  hasError: boolean;
}

export const PatientCaseComplexityContainer = styled.div`
  width: 100%;
`

export const RadioButtonOptions = styled.div`
  display: flex;
  gap: 10px;

  margin-top: 10px;
`

export const RadioButtonOption = styled.div<OptionStylesProps>`
  flex: 1;

  span {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 20px;
    height: 20px;

    margin: -10px auto 0;

    background: #1f35b5;

    border-radius: 10px;
  }

  button {
    padding: 10px 0;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    border-color: ${(props) => (props.hasError ? '#ff4949' : '')};

    border-style: solid;

    svg {
      fill: ${(props) => (props.isSelected ? '#1f35b5' : '#4b4b4b')};
    }

    p {
      color: ${(props) => (props.isSelected ? '#1f35b5' : '#4b4b4b')};

      height: 35px;

      display: flex;
      align-items: center;
    }

    &:hover {
      background-color: ${(props) =>
    props.isSelected ? '#E8EAF8' : '#F5F5F5'};
    }
  }
`

const colorsByComplexityType = {
  NORMAL: '#898989',
  LOW: '#1F35B5',
  MODERATE: '#F9A435',
  SERIOUS: '#FC4949',
}

interface BoxInfoProps {
  type: PatientCaseComplexityType;
}

export const BoxInfo = styled.div<BoxInfoProps>`
  background-color: #fffcb5;
  margin: 10px 0 10px;
  padding: 15px 20px;
  border-radius: 10px;
  strong {
    color: ${({ type }) => colorsByComplexityType[type]};
  }
`
